export enum Plan {
  PremiumPlus = 'PremiumPlus',
  Premium29 = "Premium29",
  Premium = 'Premium'
}
